import { CellProps } from 'react-table'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useListView } from '../../core/ListViewProvider'
import {
  PlainHeader,
  SelectionCell,
  SelectionHeader,
  sortableColumn,
  StackedCell,
  TableColumn,
} from '../../../../../../components'
import { AtendimentoList } from '../../../../atendimento/core/_models'
import { FinanceiroAtendimentosActionsCell } from './FinanceiroAtendimentosActionsCell'
import { TFunction } from '_metronic/i18n/Metronici18n'

export const financeiroAtendimentosColumns = (
  t: TFunction
): ReadonlyArray<TableColumn<AtendimentoList>> => [
  {
    Header: (props) => (
      <SelectionHeader
        useListView={useListView}
        tableProps={props}
        ariaLabel='Selecionar todos desta página'
      />
    ),
    id: 'selection',
    cellWidth: '48px',
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <SelectionCell
        useListView={useListView}
        id={row.original.id}
        ariaLabel={`Selecionar atendimento ${row.original.protocolo ?? ''}`}
      />
    ),
  },
  // Paciente com o protocolo como apoio; os dois seguem ordenáveis.
  sortableColumn<AtendimentoList>({
    id: 'paciente.pessoa.nome',
    useQueryRequest,
    fields: [
      { field: 'paciente.pessoa.nome', label: t('cols.paciente') },
      { field: 'protocolo', label: t('cols.protocolo') },
    ],
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <StackedCell
        primary={row.original.paciente?.pessoa?.nome}
        secondary={row.original.protocolo}
      />
    ),
  }),
  // Especialidade com o tipo de atendimento como apoio; os dois seguem ordenáveis.
  sortableColumn<AtendimentoList>({
    id: 'especialidade.nome',
    cellWidth: '200px',
    useQueryRequest,
    fields: [
      { field: 'especialidade.nome', label: t('cols.especialidade') },
      { field: 'tipo', label: t('cols.tipo') },
    ],
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <StackedCell primary={row.original.especialidade?.nome} secondary={row.original.tipo} />
    ),
  }),
  // Instituição com o profissional como apoio (o profissional não é ordenável no backend).
  sortableColumn<AtendimentoList>({
    id: 'empresa.nomeFantasia',
    cellWidth: '240px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [
      { field: 'empresa.nomeFantasia', label: t('empresa.label') },
      { field: 'responsavelInicial.nome', label: t('cols.profissional'), sortable: false },
    ],
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <StackedCell
        primary={row.original.empresa?.nomeFantasia}
        secondary={row.original.responsavelInicial?.nome}
      />
    ),
  }),
  // ATENÇÃO (herdado): o cabeçalho diz "Data de término", mas o valor e a ordenação são da
  // solicitação. Mantido como estava até confirmar qual data o financeiro precisa ver.
  sortableColumn<AtendimentoList>({
    id: 'solicitacao',
    cellWidth: '168px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'solicitacao', label: t('cols.dataTermino') }],
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <StackedCell tabular primary={row.original.solicitacaoFormatada} />
    ),
  }),
  // Retorno em texto (antes era só um ponto colorido: cor não pode ser o único significado).
  sortableColumn<AtendimentoList>({
    id: 'retorno',
    cellWidth: '104px',
    useQueryRequest,
    fields: [{ field: 'retorno', label: t('cols.retorno') }],
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <StackedCell primary={row.original.retorno ? 'Sim' : 'Não'} />
    ),
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '96px',
    align: 'end',
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <FinanceiroAtendimentosActionsCell atendimento={row.original} />
    ),
  },
]
